export default function ReportInstanceCommentDirective() {
  return {
    template: require('./report-instance-comment.html'),
    scope: {
      reportInstanceComment: '=',
    },
    controller: 'MRReportInstanceCommentController',
    controllerAs: 'mrReportInstanceCommentVM',
    bindToController: true,
    replace: true
  };
}
